/* eslint-disable react/no-did-mount-set-state */
import React from 'react';
import PropTypes from 'prop-types';
import { parseQueryString } from '@vezeeta/web-utils';
import isoCodes from '../../utils/Countries';
import fetchCmsContent from '../../api/cms';
import './withCMS.scss';

const withCMS = (Component) => {
  class WrapperComponent extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        brandKey: '',
        cmsTheme: null,
        cmsCommonContent: null,
        cmsApiStatus: 'Credit Card Payment Portal ...',
      };
      let urlToParse = window.location.search;
      if (urlToParse) {
        urlToParse = parseQueryString(urlToParse);
        if (urlToParse.brandKey && urlToParse.countryId) {
          localStorage.setItem('brandKey', urlToParse.brandKey);
          localStorage.setItem('countryIsoCode', isoCodes[urlToParse.countryId]);
        } else if (window.location.pathname === '/') {
          localStorage.removeItem('brandKey');
          localStorage.removeItem('countryIsoCode');
        }
      }
      this.state = {
        ...this.state,
        brandKey: localStorage.getItem('brandKey'),
        countryIsoCode: localStorage.getItem('countryIsoCode'),

      };
    }
    async componentDidMount() {
      try {
        const { brandKey, countryIsoCode } = this.state;
        if (brandKey && countryIsoCode) {
          document.title = 'Credit Card Payment';
          document.querySelector('[rel="shortcut icon"]').href = `${process.env.REACT_APP_VEZEETA_CDN}/${process.env.REACT_APP_VEZEETA_CDN_FAVICONS}/${brandKey}/favicon.ico`;
          const lang = `en-${countryIsoCode}`;
          const [themeRes, commonRes] = await Promise.all([fetchCmsContent(brandKey, 'Theme'), fetchCmsContent(brandKey, 'WebsiteCommonContent', lang)]);
          if (commonRes.ok) {
            const cmsCommonContent = await commonRes.json();
            this.setState({
              cmsCommonContent: cmsCommonContent[0],
            });
          }
          if (themeRes.ok) {
            const themeResJson = await themeRes.json();
            const theme = themeResJson[0];
            const primary = theme.mainBrandColor.colors[0].hexColor;
            const secondary = theme.secondaryBrandColor.colors[0].hexColor;

            if (primary && secondary) {
              const style = document.createElement('style');
              style.textContent = `
                header {
                  background-color: ${primary};
                }
                button.btn.btn--red, button.btn.btn--red:hover {
                  background-color: ${secondary};
                }
                button.btn.btn--blue, button.btn.btn--blue:hover {
                  background-color: ${secondary};
                }
                .input-field input:focus {
                  border-bottom-color: ${primary};
                }
                .input-field.input-field--danger input {
                  border-bottom-color: #ef0f0f;
                }
                .input-field input:focus + .helperIcon svg path {
                  fill: ${primary}
                }
                .input-field.input-field--danger input + .helperIcon svg path {
                  fill: #ef0f0f;
                }
                .spinner .path {
                  stroke: ${primary};
                }
              `;
              document.head.append(style);
              this.setState({
                cmsTheme: theme,
              });
            }
          }
        }
      } catch (error) {
        this.setState({
          cmsApiStatus: 'Sorry something went wrong, please try again later',
        });
      }
    }

    calculateUrlForImageAsset = (imageName, imageCmsKey) => {
      const { brandKey } = this.state;
      if (brandKey) {
        return `${process.env.REACT_APP_VEZEETA_CMS_MIDDLEWARE_URL}/dA/${imageCmsKey}`;
      }
      return `${process.env.REACT_APP_ASSETS_CDN_GATEWAY_BASE_URL}/Assets/Img/${imageName}`;
    };

    render() {
      const {
        brandKey, cmsTheme, cmsCommonContent, cmsApiStatus,
      } = this.state;
      if (brandKey) {
        return cmsTheme && cmsCommonContent ? <Component
          {...this.props}
          brandKey={brandKey}
          commonContent={cmsCommonContent}
          calculateUrlForImageAsset={this.calculateUrlForImageAsset}
        /> : <p className="loading">{cmsApiStatus}</p>;
      }
      return <Component {...this.props} calculateUrlForImageAsset={this.calculateUrlForImageAsset} />;
    }
  }

  WrapperComponent.propTypes = {
    theme: PropTypes.shape({
      mainBrandColor: PropTypes.shape({
        colors: PropTypes.arrayOf([
          PropTypes.shape({
            hexColor: PropTypes.string,
          }),
        ]),
      }),
    }).isRequired,
  };

  return WrapperComponent;
};

export default withCMS;



// WEBPACK FOOTER //
// ./src/components/withCMS/withCMS.js